.root {
  align-items: center;
  border-radius: 100px;
  color: var(--color-background);
  display: inline-flex;
  flex-shrink: 0;
  font-weight: 600;
  justify-content: center;
  overflow: hidden;
}

.img {
  height: 100%;
  object-fit: cover;
  width: 100%;
}

.root-size-sm {
  font-size: 11px;
  height: 32px;
  width: 32px;
}

.root-size-md {
  font-size: 12px;
  height: 28px;
  width: 28px;
}

.root-size-lg {
  font-size: 14px;
  height: 36px;
  width: 36px;
}

.root-size-xl {
  font-size: 16px;
  height: 48px;
  width: 48px;
}

.root-color-indigo { background: var(--color-avatar-indigo); }
.root-color-violet { background: var(--color-avatar-violet); }
.root-color-pink { background: var(--color-avatar-pink); }
.root-color-green { background: var(--color-avatar-green); }
.root-color-amber { background: var(--color-avatar-amber); }

.account-icon {
  align-items: center;
  border-radius: 4px;
  display: inline-flex;
  height: 20px;
  justify-content: center;
  width: 20px;
}

.account-icon-variant-company {
  background: var(--color-secondary);
  color: var(--color-muted);
}

.account-icon-variant-partner {
  background: var(--color-success);
  color: var(--color-success-alt);
}

.account-icon-variant-person {
  background: var(--color-accent);
  color: var(--color-accent-foreground);
}
